/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;

    return hash({
      subject: store.findRecord('goals/subject', params.subject_id),
      categories: store.findAll('goals/category'),
      subcategories: store.findAll('goals/subcategory'),
      goals: store.findAll('goals/goal', { subjectId: params.subject_id }),
      allTeacherSubjects: store.findAll('goals/subject', {
        visibleToTeacher: true,
      }),
      allGoals: store.findAll('goals/goal'),
    });
  }
}
